import { HELPSCOUT_API_KEY } from "@/config/constants";
import { useAuth } from "@/contexts/auth/useAuth";
import { setBeaconReady } from "@/lib/helpscout";
import { useEffect } from "react";

interface BeaconFunc {
    (method: string, options?: unknown, data?: unknown): void;
    readyQueue: Array<{ method: string; options?: unknown; data?: unknown }>;
}

export const HelpScoutBeacon = () => {
    const { user } = useAuth();

    useEffect(() => {
        // Skip if no API key is provided
        if (!HELPSCOUT_API_KEY) return;

        // Initialize HelpScout Beacon
        (function (w: Window, d: Document) {
            function a() {
                const e = d.getElementsByTagName("script")[0];
                const n = d.createElement("script");
                n.type = "text/javascript";
                n.async = true;
                n.src = "https://beacon-v2.helpscout.net";
                e.parentNode?.insertBefore(n, e);
            }

            if (
                ((w.Beacon = function (t: string, n: unknown, a: unknown) {
                    (w.Beacon as BeaconFunc).readyQueue.push({
                        method: t,
                        options: n,
                        data: a,
                    });
                } as Window["Beacon"]),
                ((w.Beacon as BeaconFunc).readyQueue = []),
                "complete" === d.readyState)
            ) {
                return a();
            }

            // Handle different browser support for load event
            if (w.attachEvent) {
                w.attachEvent("onload", a);
            } else {
                w.addEventListener("load", a, false);
            }
        })(window, document);

        // Initialize Beacon with API key
        window.Beacon?.("init", HELPSCOUT_API_KEY);

        // No floating launcher; the sidebar Help item opens the popup, and
        // this positions it bottom-right (config here overrides the Beacon
        // Builder display settings)
        window.Beacon?.("config", {
            display: { style: "manual", position: "right" },
        });
        window.Beacon?.("on", "ready", () => setBeaconReady(true));

        return () => {
            setBeaconReady(false);
            window.Beacon?.("destroy");
        };
    }, []);

    // Identify user if available
    useEffect(() => {
        if (!user?.email) return;

        const userName =
            user.first_name && user.last_name
                ? `${user.first_name} ${user.last_name}`
                : user.email.split("@")[0];

        window.Beacon?.("identify", {
            name: userName,
            email: user.email,
        });
    }, [user]);

    return null;
};

export default HelpScoutBeacon;
